import type { JobResponseType } from './types';
import { get, writable } from 'svelte/store';
import type { VehicleColorsResponseType } from '../Vehicles/VehiclesApi';

export type JOB_COLOR_METHOD_TYPE = 'target_date' | 'assigned_vehicle_id';
export let vehicleColors = writable<VehicleColorsResponseType>({});

export function getJobColor(
    job: JobResponseType,
    today: string | null = null,
    jobColorMethod: JOB_COLOR_METHOD_TYPE = 'target_date'
): string {
    switch (jobColorMethod) {
        case 'target_date':
            return _getJobColorByTargetDate(job, today);
        case 'assigned_vehicle_id':
            return _getJobColorByAssignedVehicleId(job);
        default:
            throw new Error('Invalid job color method: ' + jobColorMethod);
    }
}

function _getJobColorByTargetDate(job: JobResponseType, today: string | null = null): string {
    // today is a string in the format 'YYYY-MM-DD'
    if (today === null) {
        today = (function () {
            let d = new Date();
            return (
                d.getFullYear() +
                '-' +
                ('0' + (d.getMonth() + 1)).slice(-2) +
                '-' +
                ('0' + d.getDate()).slice(-2)
            );
        })();
    }
    let color = '#777777';
    if (job.process_status > 1) {
        color = job.process_status < 4 ? '#60b9e6' : '#0887c7';
    } else {
        if (
            (job.target_date && job.target_date <= today) ||
            (job.end_date && job.end_date <= today)
        ) {
            color = '#d93b4d';
        } else if (
            !job.target_date &&
            (!job.start_date || job.start_date <= today) &&
            (!job.end_date || job.end_date > today)
        ) {
            color = '#e6c560';
        } else if (job.start_date &&
            ((job.target_date && job.target_date > today) ||
            (!job.target_date && job.start_date > today))
        ) {
            color = '#7bbb6d';
        }
    }
    return color;
}

function _getJobColorByAssignedVehicleId(job: JobResponseType): string {
    let color = '#f9e196';
    if (job.assigned_vehicle_id) {
        color = get(vehicleColors)[job.assigned_vehicle_id] || '#ffffff';
    } else if (job.vehicle_id) {
        color = get(vehicleColors)[job.vehicle_id] || '#777777';
    }
    return color;
}
